import {FC, memo} from "react";

interface DateLabel {
  mouth: string
  day: string
}

const DateLabel: FC<DateLabel> = ({mouth, day}) => {
  return (
    <div className="date-label">
      <div className="date-label__day">{day}</div>
      <div className="date-label__mouth">{mouth}</div>
    </div>
  )
}

export default memo(DateLabel)
